import HeroCanvas from './graphics/HeroCanvas.jsx';

const stats = [
  { value: '50+', label: 'Acres Optimized' },
  { value: '200+', label: 'Investors Active' },
];

function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-canvas">
        <HeroCanvas />
      </div>

      <div className="hero-content">
        <h1 className="hero-title">
          The Triangle Ecosystem
          <br />
          <span className="accent">for Real Estate</span>
        </h1>
        <p className="hero-sub">
          We transform real estate opportunities through demand analysis, strategic design and
          capital alignment.
        </p>
        <div className="hero-btns">
          <a href="#model" className="btn-primary">
            Explore the Model
          </a>
          <a href="#opportunities" className="btn-ghost">
            View Opportunities
          </a>
        </div>
      </div>

      <div className="hero-stats">
        {stats.map((item) => (
          <div key={item.label} className="hero-stat">
            <div className="n">
              {item.value.replace('+', '')}
              <em>+</em>
            </div>
            <div className="l">{item.label}</div>
          </div>
        ))}
      </div>

      <div className="scroll-ind">
        <div className="scroll-txt">Scroll</div>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}

export default HeroSection;
